/**
 * CSRF token management utilities.
 *
 * These functions manage the CSRF token stored in sessionStorage.
 * The token is automatically set by the login process and cleared on logout.
 * The API client automatically includes the CSRF token in state-changing requests.
 */

/**
 * Retrieves the current CSRF token from sessionStorage.
 * Returns null if no token is set.
 */
export const getCsrfToken = (): string | null => {
  return sessionStorage.getItem('csrf_token');
};

/**
 * Stores the CSRF token in sessionStorage.
 * Should be called after login or session refresh when a new token is received.
 */
export const setCsrfToken = (token: string): void => {
  sessionStorage.setItem('csrf_token', token);
};

/**
 * Removes the CSRF token from sessionStorage.
 * Should be called during logout to ensure the token is cleared.
 */
export const clearCsrfToken = (): void => {
  sessionStorage.removeItem('csrf_token');
};
